import { gql } from "@/__generated__/gql";

export const ACTION_DETAILS_STUDENT_LIST = gql(`
  query ActionDetailsStudentList (
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orgId: ID!
    $imageSize: Int = 400
    $argument: StudentListArgumentInput!
    $actionId: ID!
  ) {
    node(id: $orgId) {
      ... on Organization {
        id
        studentList(first: $first, after: $after, last: $last, before: $before, argument: $argument) {
          edges {
            node {
              id
              uuid
              profilePhoto {
                id
                url(size: $imageSize)
              }

              studentOrganizationStatus(organizationId: $orgId) {
                name
                goingStatus
                funnelState
                crmUrl
                phoneNumber
                rise {
                  riseUserActionStudentStatus(riseUserActionId: $actionId) {
                    id
                    status
                  }
                }
              }
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
          }
          totalCount
        }
      }
    }
  }
`);
